import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'travel-insurance-disclosure-message',
  props: {
  id: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return { __sfc: true, }
}

})